export default __webpack_public_path__ + "static/media/defaultBackground.d3f36676.png";